import React from 'react';
import PropTypes from 'prop-types';

const ControlBar = ({ item, changeValue }) => {
  return (
    <div className="control-bar">
      <button
        className="control-bar__item control-bar__counter minus"
        onClick={() => changeValue(item, 'minus')}></button>
      <p className="control-bar__value">{item.value}</p>
      <button
        className="control-bar__item control-bar__counter plus"
        onClick={() => changeValue(item, 'plus')}></button>
    </div>
  );
};

ControlBar.propTypes = {
  item: PropTypes.object,
  changeValue: PropTypes.func,
};

export default ControlBar;
